import { DetailsList, Selection, DetailsListLayoutMode, IColumn, Icon, MarqueeSelection, Stack, TooltipHost, CommandBar, ICommandBarItemProps, Pivot, PivotItem, Persona, IPersonaSharedProps, PersonaSize, ComboBox, IComboBox, IComboBoxOption } from "@fluentui/react";
import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { HeadingBar } from "../../../components/generic/HeadingBar";
import { PanelGenerico } from "../../../components/generic/PanelGenerico";
import { ISearch } from "../../../Interfaces/base/IBase";
import { ListaPersona } from "../../../Interfaces/IListaVerificacion";
import { IOptionPersona, IPersona } from "../../../Interfaces/IPersona";
import ListaVerificacionService from "../../../services/listaVerificacionService";
import { _initialFilter, _initialPagination, _onRenderHeader } from "../../../utils/helpers/helpers";
import themeBase from "../../../utils/theme/themeBase";
import { useBoolean } from "@fluentui/react-hooks";
import { PaginationFooter } from "../../../components/PaginationFooter/PaginationFooter";
import { IPagination } from "../../../Interfaces/base/ITable";
import { Ifilter } from "../../../Interfaces/filter";
import { IpanelGeneric } from "../../../Interfaces/IPanel";
import { FormAsignacion } from "./FilterEquipoModelo";
import HeaderTable from "../../../components/generic/HeaderTable";
import IconHelper from "../../../utils/helpers/iconHelper";
import { TableBase } from "../../../components/Table/TableBase";
import DialogDeleteBase from "../../../components/generic/DialogDeleteBase";

interface IFormModel {
    personaId?: string,
    equipoModeloId?: string,
}
const INITIAL_MODEL = {
    personaId: '',
    equipoModeloId: '',
}

function DellateEquipoModelo({ subTitle = '' }) {
    let { id } = useParams();

    const [data, setdata] = useState([]);
    const [isOpnenAsignacion, { setTrue: openAsignacion, setFalse: dismissAsignacion }] = useBoolean(false);

    const [model, setmodel] = useState<IFormModel>(INITIAL_MODEL);

    /**CONFIRMAR UNA ELIMINACION */
    const [hidePDF, { toggle: toggleHidePDF }] = useBoolean(true);
    const [hidePropressDelete, { toggle: PropressDelete }] = useBoolean(false);
    const [itemTable, setItemTable] = useState<ListaPersona | null>(null);

    /* Pagination */
    const [filter, setFilter] = useState<Ifilter>(_initialFilter());

    const [currentPage, setCurrentPage] = useState(_initialPagination().currentPage);
    const [pageSize, setPageSize] = useState(_initialPagination().pageSize);
    const [total, setTotal] = useState(_initialPagination().total);

    const [pagIngreso, setPagIngreso] = useState<IPagination>({
        ..._initialPagination(),
        onPageChange: (page) => setCurrentPage(page),
        onSizeChange: (pageSize) => setPageSize(pageSize),
    });


    //CAPTURA DE TAMAÑO DE PAGINA
    const _getPageSize = (value: number) => {
        console.log("Tamaño de pagina : ", value)
        setPageSize(value)
        setFilter({ ...filter, skip: (currentPage - 1) * pageSize, take: value, });
        setPagIngreso({ ...pagIngreso, pageSize: value, });
    }
    /* Hook Pagination */
    useEffect(() => {
        setPagIngreso({ ...pagIngreso, onSizeChange: () => setPageSize(pageSize), })
    }, [pageSize]);

    useEffect(() => {
        setPagIngreso({
            ...pagIngreso,
            currentPage: currentPage,
        });

        /* Solo si no es la primera carga actualiza el paginador */
        if (currentPage >= 1) {
            if (filter) {
                setFilter({
                    ...filter,
                    skip: (currentPage - 1) * pageSize,
                    take: pageSize,
                });
            }
        }
    }, [currentPage]);


    useEffect(() => {
        setPagIngreso({
            ...pagIngreso,
            total: total,
        });
    }, [total]);


    useEffect(() => {
        loadData()
        setmodel({ ...model, equipoModeloId: id?.toString() })
    }, []);

    const loadData = () => {
        let query: any = {};
        query.EquipoModeloId = id;
        setdata([])
        ListaVerificacionService.listarAutorizaciones(query).then(x => {
            setTotal(x.data.total)
            // console.log(x.data.total)
            setdata(x.data.data)
        });
    }

    const EliminarAsignado = (item: ListaPersona) => {
        PropressDelete()
        let body: any = {};
        body.personaId = item.personaId;
        body.equipoModeloId = item.equipoModeloId;
        console.log(body)
        ListaVerificacionService.eliminarAutorizacion(body).then((response: any) => {
            if (response.status == 200) {
                loadData()
                PropressDelete()
                toggleHidePDF()
            }
        }).catch((e: Error) => {
            console.log(e);
            alert(e)
            PropressDelete()
            toggleHidePDF()
            loadData()
        });
    }


    const _selection = new Selection({
        onSelectionChanged: () => {
        },
    });

    const cancelarAsignacion = () => {
        dismissAsignacion()
        setmodel({ ...model, personaId: '' })
        setDataInForm(undefined)
    }

    const confirmDelete = () => {
        if (itemTable)
            EliminarAsignado(itemTable)
        else
            alert("Id vacio o nulo ")
    }

    const _columns: IColumn[] = [
        {
            key: "persona",
            name: "Persona",
            fieldName: "persona",
            minWidth: 200,
            maxWidth: 300,
            isResizable: true,
            // onRender: (item: any) => (
            //     <Persona
            //         {...examplePersona}
            //         text={item.persona}
            //         size={PersonaSize.size8}
            //         // presence={PersonaPresence.online}
            //         // hidePersonaDetails={!renderDetails}
            //         imageAlt="Annie Lindqvist, status is online"
            //     />
            // )
        },
        {
            key: "opciones",
            name: "Opciones",
            fieldName: "opciones",
            minWidth: 100,
            maxWidth: 150,
            isResizable: true,
            onRender: (item: ListaPersona) => (
                <>
                    <TooltipHost content={`Eliminar`}>
                        <Icon
                            className="ms-fontSize-16 "
                            iconName='Trash'
                            style={{ cursor: 'pointer', color: "red" }}
                            onClick={() => {
                                setItemTable(item)
                                toggleHidePDF()
                                // EliminarAsignado(item)
                            }}
                        />
                    </TooltipHost>
                </>
            ),
        },
    ];
    const _Items: ICommandBarItemProps[] = [
        {
            ...IconHelper.ICON_ADD,
            onClick: openAsignacion,
        },
    ];

    const _FarItems: ICommandBarItemProps[] = [
        {
            ...IconHelper.ICON_BACK,
            onClick: (arg) => { window.history.back() },
        },
    ];


    const [dataInForm, setDataInForm] = useState<IFormModel | undefined>(undefined);
    const childToParent = (childdata) => {
        setDataInForm(childdata);
        console.log(childdata)
    }

    const AsignarPersona = () => {
        console.log(dataInForm)

        let mod: any = { EquipoModeloId: '', personaId: [] };
        mod.EquipoModeloId = model.equipoModeloId;
        if (dataInForm)
            mod.personaId.push(dataInForm.personaId)

        ListaVerificacionService.AutorizacionPersonaEquipo(mod).then((x) => {
            dismissAsignacion()
            setDataInForm(undefined)
            loadData()
            console.log(x.data)
        }).catch((e: Error) => {
            alert(e.message)
        });
    }
    return (
        <>
            {/* <HeadingBar
                title="Asignacion"
                subTitle=" Asigna personal a equipo modelo"
                subTitle2="Equipo..."
                searchPlaceholder="Buscar"
            // searchChange={_onChangeText}
            // searchHandler={_onPress}
            // searchValue={_getFilter()}
            // onClearHandler={_onClearSearch}
            /> */}

            <Stack padding={10}>
                <HeaderTable iconName="ReminderGroup" title="Asignación" subTitle="Personal Asiganado" />
            </Stack>
            <Stack>
                <TableBase
                    data={data}
                    column={_columns}
                    getPageSize={_getPageSize}
                    isLoading={false}
                    pagination={pagIngreso}
                    leftBar={_Items}
                    rigthBar={_FarItems}
                    layout={DetailsListLayoutMode.justified}
                />
            </Stack>
            {/* <Pivot aria-label="Large Link Size Pivot Example" linkSize="large" >
                <PivotItem headerText="Personal Asignado" itemKey="2" key={2}>
                    <div className="ms-Grid-col ms-sm12 ms-lg12">
                        <CommandBar
                            items={_Items}
                            farItems={_FarItems}
                            styles={themeBase.commadStyles}
                        />
                    </div>
                    <Stack style={themeBase._borderBottom}>
                        <MarqueeSelection selection={_selection}>
                            <DetailsList
                                items={data}
                                compact={false}
                                columns={_columns}
                                setKey="set"
                                layoutMode={DetailsListLayoutMode.justified}
                                // selection={Selection}
                                selectionPreservedOnEmptyClick={true}
                                ariaLabelForSelectionColumn="Toggle selection"
                                ariaLabelForSelectAllCheckbox="Toggle selection for all items"
                                checkButtonAriaLabel="select row"
                                styles={_onRenderHeader}
                            />
                        </MarqueeSelection>
                        <PaginationFooter total={data.length} pagination={pagIngreso}></PaginationFooter>

                    </Stack>
                </PivotItem>
            </Pivot> */}

            <PanelGenerico
                {...PanelGenericoProps}
                isOpen={isOpnenAsignacion}
                onDismiss={cancelarAsignacion}
                cancelar={cancelarAsignacion}
                enabledHeader
                registrar={AsignarPersona}
                disabledRegister={dataInForm == undefined ? true : false}
                objectRenderBodyHelp={dataInForm}
            // model={model}
            // disabledRegister={model.personaId == '' ? true : false}
            >
                <br />
                {/* <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                    <ComboBox
                        componentRef={comboBoxRef}
                        label="Persona"
                        allowFreeform
                        autoComplete='off'
                        useComboBoxAsMenuWidth
                        calloutProps={{ directionalHintFixed: true }}
                        options={persona}
                        onInput={_onUpPersona}
                        selectedKey={model.personaId}
                        onChange={_onChangePersona}
                        required
                    />
                </div> */}
                <div>
                    {/* {JSON.stringify(dataInForm, null, 2)} */}
                    <FormAsignacion childToParent={childToParent} />
                </div>
            </PanelGenerico>

            {/* CONFIRMAR UNA ELIMINACION */}
            <DialogDeleteBase
                hidden={hidePDF}
                onDismiss={toggleHidePDF}
                eliminar={confirmDelete}
                cancelar={toggleHidePDF}
                hidePropressDelete={hidePropressDelete}
            />
        </>
    );
}


export default DellateEquipoModelo;

const PanelGenericoProps: IpanelGeneric = {
    HeaderTitlesText: {
        title: "Asignacion de personal",
        subTitle: "Seleccione persona para asignar"
    },
    textRegister: "Asignar"
}